import api from '../tools/api';

export const getProducts = () => api.request(
    'products'
);
